export default __webpack_public_path__ + "static/media/stop-light.6225fded.svg";